<template>
  <v-dialog :value="true" max-width="290">
    <v-card>
      <v-card-title class="headline">Editar Forma de pagamento</v-card-title>
      <v-card-text class="pt-4">
        <v-alert type="error" v-if="errorMessage" class="mb-6">{{ errorMessage }}</v-alert>
        <v-form ref="form" @submit.prevent>
          <decimal-number
            label="Valor total"
            v-model="fields.amount_to_pay.value"
            :rules="[...fields.amount_to_pay.apiErrors]"
            @input="fields.amount_to_pay.apiErrors = []"
            outlined dense
          ></decimal-number>
          <v-text-field
            label="Número de parcelas"
            v-model="fields.number_of_installment.value"
            :rules="[...fields.number_of_installment.rules, ...fields.number_of_installment.apiErrors]"
            type="number"
            @input="fields.number_of_installment.apiErrors = []"
            outlined dense
          ></v-text-field>
          <v-select
            v-model="fields.method.value"
            dense
            outlined
            label="Forma de pagamento"
            :items="methodOptions"
          />
          <v-select
            v-if="fields.method.value && fields.method.value !== 'monthly'"
            v-model="fields.period.value"
            dense
            outlined
            label="Período"
            :items="periodOptions"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" :disabled="saving" text @click="$emit('canceled')">
          Cancelar
        </v-btn>
        <v-btn color="success" :disabled="saving" :loading="saving" text @click="saveItem()">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'
import DecimalNumber from '@/components/DecimalNumber'

export default {
  name: 'editJoined',
  components: {
    DecimalNumber
  },
  props: {
    item: {
      required: true,
      type: Object
    },
    id: {
      required: true,
      type: [String, Number]
    }
  },
  data: () => ({
    saving: false,
    fields: {
      amount_to_pay: {
        value: '',
        rules: [
          v => !!v || 'O valor total é obrigatório'
        ],
        apiErrors: []
      },
      number_of_installment: {
        value: 0,
        rules: [
          v => (!!v || v === 0) || 'O número de parcelas é obrigatório'
        ],
        apiErrors: []
      },
      method: {
        value: '',
        apiErrors: []
      },
      period: {
        value: '',
        apiErrors: []
      }
    },
    errorMessage: null
  }),
  computed: {
    apiData () {
      let data = {}
      for (let key in this.fields) {
        if (key === 'period' && this.fields.method.value === 'monthly') data[key] = 'ALL'
        else if (this.fields[key]) data[key] = this.fields[key].value
      }
      return data
    },
    methodOptions () {
      const options = [
        { value: 'monthly', text: 'Mensal' },
        { value: 'quarterly', text: 'Trimestral' },
        { value: 'semiannual', text: 'Semestral' },
        { value: 'yearly', text: 'Anual' }
      ]
      if (this.item.fundraising && this.item.fundraising.settings) {
        const fundraisingOptions = Object.keys(this.item.fundraising.settings)
        return options.filter(e => fundraisingOptions.includes(e.value))
      }
      return options
    },
    periodOptions () {
      let settings = {
        monthly: ['ALL'],
        quarterly: ['JAN|ABR|JUL|OUT', 'FEV|MAI|AGO|NOV', 'MAR|JUN|SET|DEZ'],
        semiannual: ['JAN|JUL', 'FEV|AGO', 'MAR|SET', 'ABR|OUT', 'MAI|NOV', 'JUN|DEZ'],
        yearly: ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ']
      }
      if (this.item.fundraising && this.item.fundraising.settings) {
        settings = this.item.fundraising.settings
      }
      if (this.fields.method.value) {
        return settings[this.fields.method.value] || []
      }
      return []
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    generateApiErrors (apiErrors) {
      for (let key in apiErrors) {
        if (this.fields[key]) this.fields[key].apiErrors = apiErrors[key]
      }
    },
    saveItem () {
      let vue = this
      vue.saving = true

      axios('joineds/' + vue.id, {
        method: 'patch',
        data: vue.apiData
      })
        .then(response => {
          vue.saving = false
          vue.SET_SNACKBAR({ text: 'Forma de pagamento editada' })
          vue.$emit('edited')
        })
        .catch(() => {
          vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido, por favor tente novamente' })
          vue.saving = false
          vue.$emit('error')
        })
    }
  },
  watch: {
    item: {
      handler (value) {
        let vue = this

        if (vue.item) {
          for (let key in vue.fields) {
            if (vue.item[key]) vue.fields[key].value = vue.item[key]
          }
        } else {
          vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
          vue.$emit('error')
        }
      },
      deep: true
    },
    'fields.method.value' (val) {
      if (val) this.fields.period.value = ''
    }
  },
  created () {
    if (this.id) {
      let vue = this

      if (vue.item) {
        for (let key in vue.fields) {
          if (vue.item[key]) vue.fields[key].value = vue.item[key]
        }
      } else {
        vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
        vue.$emit('error')
      }
    }
  }
}
</script>
